import { Form, Formik } from 'formik';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { SubmitButton } from 'ui-blocks/form-elements';
import { cancelImpersonateAsPartnerUser } from 'app/services/partnerImpersonationService';
import { loginUserSuccessPartner } from 'redux/auth/authActions';

const SwitchBackPartnerImpersonationForm = (props) => {
   const dispatch = useDispatch();
   const loggedInUserPartner = useSelector((state) => (state?.authReducer?.loggedInUserPartner || {}));
   const handleSubmit = useCallback((values, formikBag) => {
      cancelImpersonateAsPartnerUser().then(({ data }) => {
         formikBag.setSubmitting(false);
         if (data?.token && !(data?.error)) {
            dispatch(loginUserSuccessPartner({
               token: data.token,
            }));
         } else {
            toastr.error(`An error occurred. Please try again later.`);
         }
      })
   }, []);

   return (
      <>
         <div>
            <b>{`${ loggedInUserPartner?.fname || '' } ${ loggedInUserPartner?.lname || '' }`}</b>
            <br />
            <b>{ loggedInUserPartner?.email || '' }</b>
         </div>
         <div className='text-center m-3'>
            <Formik
               initialValues={ {} }
               validateOnChange={ false }
               validateOnBlur={ false }
               onSubmit={ handleSubmit }
            >
               {
                  (formik) => (
                     <Form>
                        <div className='text-center'>
                           <SubmitButton
                              label={'Back to Admin'}
                              isLoading={formik.isSubmitting}
                           />
                        </div>
                     </Form>
                  )
               }
            </Formik>
         </div>
      </>
   );
};

export default SwitchBackPartnerImpersonationForm;
